interface EventsBreakdownProps {
  doubles: number;
  mixed: number;
  singles: number;
  gender: string;
  className?: string;
}

export const EventsBreakdown = ({
  doubles,
  mixed,
  singles,
  gender,
  className,
}: EventsBreakdownProps) => {
  const prefix = gender === 'M' ? 'M' : 'W';
  return (
    <div className={className ?? 'flex justify-center gap-x-3 text-xs text-gray-500'}>
      <span>
        {prefix}D:{doubles}
      </span>
      <span>
        {prefix}X:{mixed}
      </span>
      <span>
        {prefix}S:{singles}
      </span>
    </div>
  );
};
